const params = {
    outerRadius: 130,
    innerRadiusProp: 0.5,
    padding: 25,
    opacity: 0.8,
    fadeInOutDuration: 100,
    hoverOpacity: 0.3,
};

export default params;